<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>
        <LoadOverlay :visible="overlay"></LoadOverlay>

        <b-form-group
          label="Tipo de documento"
          label-for="listaTipoDocumentoFormControlInput"
          class="col-12 col-sm-6 mb-3"
        >
          <b-form-select
            id="listaTipoDocumentoFormControlInput"
            v-model="tipoDocumentoSelected"
            :options="tiposdocumentos"
            class="form-select"
          >
            <template #first>
              <b-form-select-option value="" disabled>-- Seleccione un tipo de documento --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group>
            <button v-on:click="clearFilter" type="button" class="btn btn-secondary button-limpiar">
                Limpiar filtro
            </button>
        </b-form-group>

    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import LoadOverlay from '@/components/shared/Load-overlay.vue'
import { applyDestinationFilter } from '@/plugins/complianceScripts/index.js'

export default {
    name: 'DocumentFilterType',

    data() {
        return {
            tipoDocumentoSelected: '',
            tiposdocumentos: [],

            overlay: false,

            filter: {
                page: 1,
                pageSize: InitPageSize.DocumentPageSize
            },
        }
    },

    async mounted() {
        await this.getDocumentTypes();
    },

    components:{
        AlertDismiss,
        LoadOverlay
    },

    computed:{
        ...mapGetters(["getRole"])
    },

    methods:{
        ...mapActions(["allDocumentType", "allDocumentByType"]),

        setOverlay(){
            this.overlay = ! this.overlay;
        },

        clearFilter() {
            this.getDocumentTypes();
            this.tipoDocumentoSelected = '';
            this.$eventBus.$emit(EventNames.ClearFilterDocumen, this.filter);
        },

        async getDocumentTypes(){
            let documentType = await this.allDocumentType();

            if (documentType.isError) {
                this.$refs.alertDismiss.showAlert(documentType.message);
                return;
            }

            this.tiposdocumentos = documentType.data.map(( type ) => {
                return { value: type.id, text: type.name }
            }).sort(( a, b ) => {
                return a.text.localeCompare(b.text);
            })
        },

        async getDocument(){
            this.setOverlay();
            let document = await this.allDocumentByType(
                { 
                    documentTypeId: this.tipoDocumentoSelected,
                    destination: applyDestinationFilter(this.getRole)
                 });

            if (document.isError) {
                this.setOverlay();
                this.$refs.alertDismiss.showAlert(document.message);
                return;
            }

            this.$eventBus.$emit(EventNames.FilterDocumenType, document);
            this.setOverlay();
        }
    },

    watch:{
        'tipoDocumentoSelected'(newDocType){
            if(newDocType != ''){
                this.getDocument()
            }
        }
    }

}
</script>
<style scoped>
.button-limpiar {
    --bs-btn-padding-y: .25rem;
    --bs-btn-padding-x: .5rem;
    --bs-btn-font-size: .75rem;
}
</style>